// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NearestProviderForm-nearestProviderLinkContainer-Zsris {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.NearestProviderForm-nearestProviderImgContainer-sDfbh,
.NearestProviderForm-nearestNoServiceImgContainer-feden {
    width: 100%;
    max-width: 305px;
    padding: 24px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 18px;
    margin-bottom: 18px;
    border-radius: var(--radius-3);
}

@media (max-width: 767px) {

    .NearestProviderForm-nearestProviderImgContainer-sDfbh,
    .NearestProviderForm-nearestNoServiceImgContainer-feden {
        padding: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NearestProviderForm/NearestProviderForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,aAAa;IACjB;AACJ","sourcesContent":[".nearestProviderLinkContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.nearestProviderImgContainer,\n.nearestNoServiceImgContainer {\n    width: 100%;\n    max-width: 305px;\n    padding: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 18px;\n    margin-bottom: 18px;\n    border-radius: var(--radius-3);\n}\n\n@media (max-width: 767px) {\n\n    .nearestProviderImgContainer,\n    .nearestNoServiceImgContainer {\n        padding: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nearestProviderLinkContainer": `NearestProviderForm-nearestProviderLinkContainer-Zsris`,
	"nearestProviderImgContainer": `NearestProviderForm-nearestProviderImgContainer-sDfbh`,
	"nearestNoServiceImgContainer": `NearestProviderForm-nearestNoServiceImgContainer-feden`
};
module.exports = ___CSS_LOADER_EXPORT___;
